import { ENV } from '../config/constant';
import { axios } from '../config/axios';
import { sliceParamAarry } from '../config/utils';
const { VUE_APP_API_HOST_ZLZ: HOST } = ENV;

/**
 * * 获取报告列表
 * @param {number} page 当前分页
 * @param {number} pageSize 分页大小
 * @param {number} createTimeAsc 创建时间
 * @param {number} frameContent 搜索框
 * @param {number} inspectStatusEnum 巡查状态
 * @param {number} relicDistrictEnum 所属区域
 * @param {number} inspectTypeEnum 巡查类型
 * @param {number} relicFromUserIdAsc 按用户编号排序
 */
export function searchReports({
  createTimeAsc,
  frameContent,
  inspectStatusEnum,
  inspectTypeEnum,
  page = 1,
  pageSize = 20,
  relicAutoIncrementId,
  relicDistrictEnum,
  relicFromUserIdAsc,
  createTimeStart,
  createTimeEnd
} = {}) {
  return axios.get(`${HOST}/inspectreport/table`, {
    params: {
      createTimeAsc,
      frameContent,
      inspectStatusEnum,
      inspectTypeEnum,
      page,
      pageSize,
      relicAutoIncrementId,
      relicDistrictEnum,
      relicFromUserIdAsc,
      createTimeEnd,
      createTimeStart
    }
  });
}
/**
 * 添加巡查报告
 * @param {Object} params
 * @param {string} params.relicAutoIncrementId 建筑自增id
 * @param {string} params.inspectStatusEnum 巡查状态
 * @param {Object} params.inspectTypeEnum 巡查类型
 * @param {Object} params.relicAddress 建筑地址
 * @param {Object} params.owner 所有人
 * @param {Object} params.ownerContact 所有人联系方式
 * @param {Object} params.user 使用人
 * @param {Object} params.userContact 使用人联系方式
 * @param {Object} params.agent 代理人
 * @param {Object} params.agentContact 代理人联系方式
 * @param {Object} params.relicDirectorEnum 管理者
 * @param {Object} params.brandStatusEnum 是否挂牌
 * @param {Object} params.facadeStatusEnum  外立面改变
 * @param {Object} params.buildingDamageStatusEnum 建筑破损
 * @param {Object} params.constructingComponentEnums, 正在施工
 * @param {Object} params.otherConstructingComponents 正在施工的其他选项
 * @param {Object} params.otherSituationEnums  其他情况
 */
export function addInspectreport(params) {
  return axios.post(`${HOST}/inspectreport/fillin`, params, {
    headers: { 'Content-Type': 'application/json' }
  });
}

/**
 * 指派巡查报告
 */
export function assignInspectreport({
  inspectorUid,
  relicAutoIncrementId,
  inspectStatusEnum = null,
  inspectTypeEnum = null,
  relicAddress = null,
  owner = null,
  ownerContact = null,
  user = null,
  userContact = null,
  agent = null,
  agentContact = null,
  relicDirectorEnum = null,
  brandStatusEnum = null,
  facadeStatusEnum = null,
  buildingDamageStatusEnum = null,
  constructingComponentEnums = null,
  otherConstructingComponents = null,
  otherSituationEnums = null
} = {}) {
  return axios.post(
    `${HOST}/inspectreport/assign`,
    {
      inspectorUid,
      relicAutoIncrementId,
      inspectStatusEnum,
      inspectTypeEnum,
      relicAddress,
      owner,
      ownerContact,
      user,
      userContact,
      agent,
      agentContact,
      relicDirectorEnum,
      brandStatusEnum,
      facadeStatusEnum,
      buildingDamageStatusEnum,
      constructingComponentEnums,
      otherConstructingComponents,
      otherSituationEnums
    },
    {
      headers: { 'Content-Type': 'application/json' }
    }
  );
}

/**
 * 通过建筑自增id查找最新的巡查报告
 */
export function searchNewestInspectreport(relicAutoIncrementId) {
  return axios.get(`${HOST}/inspectreport/newest`, {
    params: { relicAutoIncrementId }
  });
}

/**
 * 查看对应巡查报告id的巡查报告
 */
export function getReportDetail(id) {
  return axios.get(`${HOST}/inspectreport/byId`, { params: { id } });
}

/**
 * 删除巡查报告对应id的巡查报告
 */
export function deleteReport(deleteList) {
  const relicList = sliceParamAarry(deleteList);
  const promises = [];
  relicList.map(item => {
    const params = item
      .map(({ inspectReportId: id }) => `inspectReportId=${id}`)
      .join('&');
    promises.push(axios.delete(`${HOST}/inspectreport?${params}`));
  });
  return Promise.allSettled(promises);
  // return axios.delete(`${HOST}/inspectreport?${inspectReportId}`);
}

/**
 * 更新表中已有的巡查报告
 */
export function updateReport({
  userUid,
  inspectReportId,
  relicAutoIncrementId,
  inspectStatusEnum,
  inspectTypeEnum,
  relicAddress,
  owner,
  ownerContact,
  user,
  userContact,
  agent,
  agentContact,
  relicDirectorEnum,
  brandStatusEnum,
  facadeStatusEnum,
  buildingDamageStatusEnum,
  constructingComponentEnums,
  otherConstructingComponents,
  otherSituationEnums
} = {}) {
  return axios.put(
    `${HOST}/inspectreport`,
    {
      userUid,
      inspectReportId,
      relicAutoIncrementId,
      inspectStatusEnum,
      inspectTypeEnum,
      relicAddress,
      owner,
      ownerContact,
      user,
      userContact,
      agent,
      agentContact,
      relicDirectorEnum,
      brandStatusEnum,
      facadeStatusEnum,
      buildingDamageStatusEnum,
      constructingComponentEnums,
      otherConstructingComponents,
      otherSituationEnums
    },
    {
      headers: { 'Content-Type': 'application/json' }
    }
  );
}
/**
 * 插入新图片
 * [
  {
    "gaiDongBuWei": true,
    "inspectReportId": 0,
    "teSeGouJian": true,
    "thumb": "string",
    "url": "string",
    "zhuYaoLiMian": true
  }
]
 */
export function addInspectreportPhoto(photoInsertQueryList) {
  return axios.post(`${HOST}/inspectreport/photo`, photoInsertQueryList, {
    headers: { 'Content-Type': 'application/json' }
  });
}

/**
 *
 * @param {array} photoUpdateQueryList 更新已有图片属性
 * [
  {
    "gaiDongBuWei": true,
    "inspectReportPhotoId": 0,
    "teSeGouJian": true,
    "zhuYaoLiMian": true
  }
]
 */
export function updateInspectreportPhoto(photoUpdateQueryList) {
  return axios.put(`${HOST}/inspectreport/photo`, photoUpdateQueryList, {
    headers: { 'Content-Type': 'application/json' }
  });
}

/**
 * 删除图片
 */
export function deleteReportPhoto(inspectReportIds) {
  return axios.delete(`${HOST}/inspectreport/photo?${inspectReportIds}`);
}

/**
 * 查看对应报告id的照片
 */
export function getReportPhoto(inspectReportId) {
  return axios.get(`${HOST}/inspectreport/photo`, {
    params: { inspectReportId }
  });
}

/**
 * 批量更新报告照片
 */
export function updateReportPhotoList({
  photoUpdateQueryList,
  inspectReportId
}) {
  return axios.put(
    `${HOST}/inspectreport/${inspectReportId}/photo`,
    photoUpdateQueryList,
    {
      headers: { 'Content-Type': 'application/json' }
    }
  );
}
